import React from 'react';
import { Chip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { formatMerchantNumberDisplay, installmentsMatch, isMerchantRuleExpired } from '../helpers/authorizationGuide';
import { MerchantNumberRule } from '../constants/merchantNumbers';

interface MerchantRulesTableProps {
	rules: MerchantNumberRule[];
	highlightFee?: number;
	showNotes?: boolean;
}

export const MerchantRulesTable = ({ rules, highlightFee, showNotes = true }: MerchantRulesTableProps): JSX.Element => (
	<TableContainer>
		<Table size="small">
			<TableHead>
				<TableRow>
					<TableCell>Tarjeta</TableCell>
					<TableCell>N° Comercio</TableCell>
					<TableCell>Cuotas</TableCell>
					<TableCell>Validez</TableCell>
					{showNotes && <TableCell>Notas</TableCell>}
				</TableRow>
			</TableHead>
			<TableBody>
				{rules.map((rule, index) => {
					const matchesFee = highlightFee !== undefined && installmentsMatch(rule.installmentsLabel, highlightFee);
					const expired = isMerchantRuleExpired(rule.validUntil);

					return (
						<TableRow
							key={`${rule.carrierCode}-${rule.cardLabel}-${rule.installmentsLabel}-${index}`}
							sx={{ bgcolor: matchesFee ? 'success.50' : 'inherit' }}
						>
							<TableCell>{rule.cardLabel}</TableCell>
							<TableCell sx={{ fontFamily: 'monospace', fontWeight: 'bold' }}>
								{formatMerchantNumberDisplay(rule.merchantNumber)}
							</TableCell>
							<TableCell>{rule.installmentsLabel}</TableCell>
							<TableCell>
								<Chip label={rule.validUntil} size="small" color={expired ? 'error' : 'default'} variant="outlined" />
							</TableCell>
							{showNotes && (
								<TableCell>
									{rule.notes ? (
										<Typography variant="caption" color="text.secondary">
											{rule.notes}
										</Typography>
									) : (
										'—'
									)}
								</TableCell>
							)}
						</TableRow>
					);
				})}
			</TableBody>
		</Table>
	</TableContainer>
);
